import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PlusNova = (props) => {
    const width = props.width ? props.width + 'px' : '26px';
    const height = props.height ? props.height + 'px' : '27px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 26 27"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 15.0312V24.0312C15 25.1358 14.1046 26.0312 13 26.0312C11.8954 26.0312 11 25.1358 11 24.0312V15.0312H2C0.89543 15.0312 0 14.1358 0 13.0312C0 11.9266 0.895431 11.0312 2 11.0312H11V2.03125C11 0.92668 11.8954 0.03125 13 0.03125C14.1046 0.03125 15 0.926681 15 2.03125V11.0312H24C25.1046 11.0312 26 11.9266 26 13.0312C26 14.1358 25.1046 15.0312 24 15.0312H15Z"
            />
        </SvgStyled>
    );
};

export default PlusNova;
